/**
 * Microsoft Planner 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <MicrosoftPlannerIcon className="w-8 h-8" />
 * <MicrosoftPlannerIcon className="w-12 h-12" />
 * ```
 */
export function MicrosoftPlannerIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Microsoft Planner icon"
      role="img"
    >
      <title>Microsoft Planner</title>
      <g id="Microsoft Planner">
        <g id="Vector">
          <path
            d="M11.6344 20.3651C10.429 21.5705 8.47467 21.5705 7.26926 20.3651L2.90406 15.9998C1.69865 14.7944 1.69865 12.84 2.90406 11.6346L7.26926 7.2694C8.47467 6.06398 10.429 6.06398 11.6344 7.2694L15.9997 11.6346C17.2051 12.84 17.2051 14.7944 15.9997 15.9998L11.6344 20.3651Z"
            fill="url(#paint0_linear_4800_1539)"
          />
          <path
            d="M2.90406 15.9998C4.1095 17.2052 6.06387 17.2056 7.26931 16.0001L20.3653 2.9041C21.5707 1.69864 23.5251 1.69863 24.7307 2.90408L29.0959 7.2694C30.3014 8.47485 30.3014 10.4293 29.0959 11.6347L15.9999 24.7308C14.7945 25.9362 12.84 25.9362 11.6346 24.7308L2.90406 15.9998Z"
            fill="url(#paint2_linear_4800_1539)"
          />
          <path
            d="M7.26926 20.3651C8.47467 21.5705 10.429 21.5705 11.6344 20.3651L20.3651 11.6345C21.5706 10.4291 23.525 10.4291 24.7304 11.6345L29.0957 15.9999C30.3013 17.2053 30.3013 19.1598 29.0957 20.3652L20.3651 29.0958C19.1597 30.3014 17.2052 30.3014 15.9998 29.0958L7.26926 20.3651Z"
            fill="url(#paint4_linear_4800_1539)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4800_1539"
          x1="15.9999"
          y1="2.00004"
          x2="6.72937"
          y2="21.8043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8752E0" />
          <stop offset="1" stopColor="#541278" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4800_1539"
          x1="23.2127"
          y1="1.99995"
          x2="10.3231"
          y2="28.9673"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB45E0" />
          <stop offset="1" stopColor="#6C0F71" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4800_1539"
          x1="21.3778"
          y1="2.02793"
          x2="13.5491"
          y2="29.4037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3DCBFF" />
          <stop offset="1" stopColor="#00479E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
